var toSentence = require('./toSentence');

module.exports = function toSentenceSerial(array, sep, lastSep) {
  return toSentence(array, sep, lastSep, true);
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/underscore.string/toSentenceSerial.js
// module id = 833
// module chunks = 0